import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  replace(event) {
    history.replaceState({}, "", event.currentTarget.href)
  }
}
